export const ACTORS = [
  {
    id: 1,
    name: "林知远",
    enName: "Lin Zhiyuan",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20calm%20East%20Asian%20man%20in%20his%20forties%20with%20short%20dark%20hair%20and%20a%20light%20beard%2C%20wearing%20a%20dark%20shirt%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-01&orientation=portrait",
    birthday: "1979-04-18",
    birthplace: "中国 · 青岛",
    height: "182 cm",
    debut: "2003 年",
    tags: ["实力派", "悬疑专业户", "舞台剧出身"],
    quote: "角色不会因为你说得对就相信你，他只会因为你真的难过才相信你。",
    bio: [
      "林知远毕业于中央戏剧学院表演系，早年长期活跃在话剧舞台，三十岁之后才逐渐转向影视。他的表演以克制著称，很少依赖外放的台词爆发，更多靠呼吸与停顿完成情绪落点。",
      "从《雪线以南》里沉默的老韩，到《雾港迷踪》中背负旧案的刑警沈砚，他擅长处理那些把话咽回去的人物。近年开始参与剧本开发，担任多部作品的表演指导。",
    ],
  },
  {
    id: 2,
    name: "苏晚",
    enName: "Su Wan",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20her%20early%20thirties%20with%20shoulder%20length%20dark%20hair%2C%20wearing%20a%20minimal%20beige%20knit%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-02&orientation=portrait",
    birthday: "1992-11-06",
    birthplace: "中国 · 南京",
    height: "168 cm",
    debut: "2014 年",
    tags: ["文艺片", "多语种", "编剧"],
    quote: "我喜欢那些台词很少、但观众能听见她心里在说话的角色。",
    bio: [
      "苏晚最初以短片作品进入观众视野，之后在多部文艺片中塑造了安静而倔强的女性形象。她可以熟练使用中、英、法三种语言工作，因此在合拍片中频频出现。",
      "除了表演，她也参与编剧工作，《第九个春天》中关于剧场生活的部分对白由她与导演共同完成。2025 年她凭《雾港迷踪》中的林漪获得年度女配角提名。",
    ],
  },
  {
    id: 3,
    name: "顾清和",
    enName: "Gu Qinghe",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20distinguished%20East%20Asian%20man%20in%20his%20fifties%20with%20gray%20streaked%20hair%20and%20glasses%2C%20wearing%20a%20dark%20jacket%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-03&orientation=portrait",
    birthday: "1968-02-25",
    birthplace: "中国 · 上海",
    height: "178 cm",
    debut: "1992 年",
    tags: ["老戏骨", "主持人", "配音"],
    quote: "镜头前最贵的不是技巧，是你还愿不愿意相信。",
    bio: [
      "顾清和是观众非常熟悉的面孔，从九十年代的电视剧到近年的流媒体作品，他几乎见证了华语影视工业的每一次变化。声音辨识度极高，也长期为纪录片担任旁白。",
      "近年他主持的文化访谈节目《夏日放映厅》获得广泛好评，节目中他几乎不打断嘉宾，只是把问题放在桌上等对方自己走近。",
    ],
  },
  {
    id: 4,
    name: "沈墨白",
    enName: "Shen Mobai",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20thoughtful%20East%20Asian%20man%20in%20his%20mid%20thirties%20with%20short%20black%20hair%2C%20wearing%20a%20simple%20white%20shirt%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-04&orientation=portrait",
    birthday: "1988-07-14",
    birthplace: "中国 · 沈阳",
    height: "184 cm",
    debut: "2011 年",
    tags: ["年代剧", "舞台功底", "低音炮"],
    quote: "我想演那种在生活里被推着走、但始终没丢掉体面的人。",
    bio: [
      "沈墨白的成名作是一部小成本年代剧，他在其中饰演一名下岗工人。为了这个角色，他在老工业区住了两个月，跟着当地人学方言、学修自行车。",
      "此后他连续出演了《长夜将尽》《逆流而上》等现实题材作品，被认为是同代演员中最能承受长镜头的一位。业余时间仍然保持每年一部舞台剧的节奏。",
    ],
  },
  {
    id: 5,
    name: "江野",
    enName: "Jiang Ye",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20young%20East%20Asian%20man%20in%20his%20late%20twenties%20with%20wavy%20dark%20hair%2C%20wearing%20a%20light%20denim%20jacket%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-05&orientation=portrait",
    birthday: "1996-03-09",
    birthplace: "中国 · 成都",
    height: "186 cm",
    debut: "2018 年",
    tags: ["动作戏", "体能担当", "户外爱好者"],
    quote: "在山里待过之后，你会知道很多事不值得着急。",
    bio: [
      "江野以一部青春片出道，但真正让人记住他的是《雪线以南》中的向导洛桑。拍摄期间他完成了大量高海拔实景镜头，并考取了初级登山向导资格。",
      "他喜欢接身体消耗大的角色，《逆流而上》里为演好游泳教练，他每天在水里泡六个小时。近年也开始尝试科幻题材，《星轨之上》中的凯恩是他第一次全程用英文表演。",
    ],
  },
  {
    id: 6,
    name: "白露",
    enName: "Bai Lu",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20bright%20young%20East%20Asian%20woman%20in%20her%20late%20twenties%20with%20long%20straight%20black%20hair%2C%20wearing%20a%20soft%20cream%20blouse%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-06&orientation=portrait",
    birthday: "1995-09-21",
    birthplace: "中国 · 厦门",
    height: "170 cm",
    debut: "2017 年",
    tags: ["配音", "综艺常驻", "英语流利"],
    quote: "声音也是表演，只是观众看不见你在做什么。",
    bio: [
      "白露是少见的在镜头表演与配音两个领域都站稳的演员。她的声线清亮，为多部动画长片担任主要配音，《云端旅店》中的阿云被观众称为「一听就想哭的声音」。",
      "综艺方面，她在《山海食记》中作为常驻嘉宾，几乎不抢话，却总能在恰当的时候问出最让人放松的问题。",
    ],
  },
  {
    id: 7,
    name: "何叙",
    enName: "He Xu",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20warm%20middle%20aged%20East%20Asian%20man%20with%20short%20graying%20hair%20and%20a%20kind%20expression%2C%20wearing%20a%20brown%20linen%20shirt%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-07&orientation=portrait",
    birthday: "1975-12-02",
    birthplace: "中国 · 西安",
    height: "175 cm",
    debut: "2000 年",
    tags: ["主持人", "美食家", "编剧"],
    quote: "好好吃饭，是普通人最了不起的本事。",
    bio: [
      "何叙早年做过记者，后来转向纪录片与美食节目。他在《山海食记》中的主持方式几乎不像主持，更像一个坐下来蹭饭的邻居。",
      "同时他也是编剧，《胡同里的烟火》中老赵这个角色有大量细节来自他的童年记忆。他坚持不写「高光时刻」，只写日子本身。",
    ],
  },
  {
    id: 8,
    name: "温以宁",
    enName: "Wen Yining",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20of%20a%20gentle%20East%20Asian%20woman%20in%20her%20early%20thirties%20with%20a%20short%20bob%20haircut%2C%20wearing%20a%20muted%20olive%20shirt%2C%20soft%20neutral%20warm%20gray%20backdrop%2C%20gentle%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20no%20text&width=480&height=600&seq=hlwc-actor-08&orientation=portrait",
    birthday: "1991-05-30",
    birthplace: "中国 · 杭州",
    height: "165 cm",
    debut: "2013 年",
    tags: ["配音", "编剧", "文艺气质"],
    quote: "温柔不是没有力气，是把力气用在了别的地方。",
    bio: [
      "温以宁毕业于中国传媒大学播音系，早期以配音工作为主，后来逐渐转向影视表演。她的角色往往不是最抢眼的那一个，却常常是观众最后记住的那一个。",
      "她为《纸鸢与风》配音的小鸢被认为年度最佳动画配音之一。写作方面，她也参与了《云端旅店》的剧本创作，负责其中三个单元故事。",
    ],
  },
];